// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { useProductOrderContext } from '../../context'
import { VisitSelectionView } from '../visit-selection-view/VisitSelectionView'
import { OrderDeliveryType } from '../order-delivery-type/OrderDeliveryType'
import { NewProductsOrderView } from '../new-products-order-view/NewProductsOrderView'
import { MoudCombinedProductsView } from '../moud-combined-products-view/MoudCombinedProductsView'
import { ProductSelectionView } from '../product-selection-view/ProductSelectionView'
import { DoseDurationView } from '../dose-duration-view/DoseDurationView'
import { CartView } from '../cart-view/CartView'
import { CompleteProductOrderView } from '../complete-product-order-view/CompleteProductOrderView'
import { ProductPayment } from '../product-payment/ProductPayment'
import { type Address, type PastVisit } from '../../../../types/types'
import { type Product } from '../../../../types/products/productTypes'
import { PharmacyPartners, Step } from '../../common'
import delivery from 'images/common/delivery.svg'
import prescription from 'images/common/prescription.svg'

interface Props {
  title: string | null
  tabId: string
  orderAddress: Address
  accountCredit: number
  onSelectVisit: (visit: PastVisit) => void
  onSelectProduct: (product: Product) => void
  onConfirmSelection: () => void
  onConfirmDose: () => void
  onAddOrder: (address: Address, pharmacyId: string) => void
  onChangeSelection: () => void
  onPlaceOrder: () => void
}

export const StepRenderer = ({
  title,
  tabId,
  orderAddress,
  accountCredit,
  onSelectVisit,
  onSelectProduct,
  onConfirmSelection,
  onConfirmDose,
  onAddOrder,
  onChangeSelection,
  onPlaceOrder,
}: Props) => {
  const {
    currentStepId,
    visitList,
    setDeliveryType,
    goForward,
    selectedOption,
    isMHT,
    homeDeliveryPriceRange,
    setPharmacyPartnerType,
  } = useProductOrderContext()
  return (
    <>
      {currentStepId === Step.VIEW_VISIT_LIST && (
        <VisitSelectionView onSelectVisit={onSelectVisit} visits={visitList} />
      )}

      {currentStepId === Step.VIEW_ORDER_DELIVERY_TYPE && (
        <OrderDeliveryType
          title='Choose order delivery type'
          primary={{
            title: 'Home delivery',
            description: (
              <>
                <div>{`${isMHT ? '2-5' : '2-3'} days delivery ETA`}</div>
                <div>Pay QuickMD</div>
                {!isMHT && <div>Bup/Nx 8-2mg doses only</div>}
                <div>{`Medication prices range from $${homeDeliveryPriceRange.From} - $${homeDeliveryPriceRange.To}`}</div>
              </>
            ),
            icon: (
              <div className='order-delivery-type-item-icon'>
                <img role='presentation' src={delivery} alt='Delivery icon' />
              </div>
            ),
            onClick: () => {
              setPharmacyPartnerType(PharmacyPartners.honeybee.type)
              setDeliveryType('home')
              setTimeout(() => {
                goForward()
              }, 0)
            },
          }}
          secondary={{
            title: 'Pharmacy pickup',
            description: (
              <>
                <div>Same-day pickup</div>
                <div>Pay at pharmacy</div>
                <div>All dose options</div>
                <div>Prices will vary</div>
              </>
            ),
            icon: (
              <div className='order-delivery-type-item-icon'>
                <img role='presentation' src={prescription} alt='Prescription icon' />
              </div>
            ),
            onClick: () => {
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              setPharmacyPartnerType(undefined)
              setDeliveryType('pharmacy')
              setTimeout(() => {
                goForward()
              }, 0)
            },
          }}
        />
      )}
      {currentStepId === Step.VIEW_PRODUCTS_LIST && <NewProductsOrderView onSelectProduct={onSelectProduct} />}

      {currentStepId === Step.VIEW_MOUD_DELIVERY_COMBINED_PRODUCTS && <MoudCombinedProductsView />}

      {currentStepId === Step.VIEW_OPTION_LIST && (
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <ProductSelectionView title={title} onConfirmSelection={onConfirmSelection} />
      )}

      {currentStepId === Step.VIEW_DOSE_DURATION && (
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <DoseDurationView title={title} onConfirmDoseHandler={onConfirmDose} />
      )}

      {currentStepId === Step.VIEW_CART && <CartView accountCredit={accountCredit} />}

      {currentStepId === Step.VIEW_COMPLETE_ORDER && (
        <CompleteProductOrderView
          address={orderAddress}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          onAddOrder={onAddOrder}
          onChange={onChangeSelection}
          tabId={tabId}
        />
      )}

      {currentStepId === Step.VIEW_PAYMENT_ORDER && selectedOption ? <ProductPayment onPlaceOrder={onPlaceOrder} accountCredit={accountCredit} onChange={onChangeSelection} /> : null}
    </>
  )
}
